import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard.extend('referral').add('referral.breadcrumb.title', {
  name: 'referral.index'
});

const referral_items = ['user.index', 'request.index', 'profit.index'];

const referral_breadcrumbs = referral_items.map(item => {
  return module.extend(`referral.${item}`).add(`referral.breadcrumb.${item}`, {
    name: `referral.${item}`
  });
});
export { referral_breadcrumbs };
